import React from 'react'

import { Badge } from '@ui/components/Badge/Badge'

import {
  DocumentStatus,
  isDocumentStatusApproved,
  isDocumentStatusExpired,
  isDocumentStatusPendingApproval,
} from '@model/DocumentStatus'
import { NameDto } from '@model/NameDto'

interface DocumentBadgeStatusProps extends NameDto {
  type?: DocumentStatus
  onClick?: () => void
}

export const DocumentBadgeStatus: React.FC<DocumentBadgeStatusProps> = (props) => {
  const { id, name, type = DocumentStatus.None, onClick } = props
  const statusType = id | type

  if (isDocumentStatusExpired(statusType)) {
    return (
      <Badge type='danger' contrast='low' size='sm' onClick={onClick}>
        {name}
      </Badge>
    )
  }

  if (isDocumentStatusPendingApproval(statusType)) {
    return (
      <Badge type='blue' contrast='low' size='sm' onClick={onClick}>
        {name}
      </Badge>
    )
  }

  if (isDocumentStatusApproved(statusType)) {
    return (
      <Badge type='green' contrast='low' size='sm' onClick={onClick}>
        {name}
      </Badge>
    )
  }

  return (
    <Badge type='danger' contrast='low' size='sm' onClick={onClick}>
      {name}
    </Badge>
  )
}
